export enum DeviceType {
  ANDROID = 0,
  IOS = 1,
  WEB = 2,
}

export enum MaintenanceMode {
  STOP = 0,
  STANDBY = 1,
  START = 2,
}

export enum StorageKey {
  ACCESS_TOKEN = '_bid',
}

export const TOGGLE_DEBOUNCE_DELAY = 500

export const STREAM_MANAGER_PATH = '/dashboard/stream-manager'

export const INDEXED_DB_NAME = 'HmcDB'

export const MAINTENANCE_REFRESH_INTERVAL = 60 * 1000 // 60s
